import {
  PageNames,
  PageLayout,
  getResponseErrorMessage,
  DisconnectedIllustration,
} from '@diana/core';
import { Stack, Typography } from '@mui/material';

export const PerformanceReportBuilderPageError = (props: { error: unknown }) => {
  const { error } = props;
  return (
    <PageLayout name={PageNames.PERFORMANCE_BUILDER}>
      <Stack alignItems="center" spacing={2} p={5}>
        <DisconnectedIllustration />
        <Typography>{getResponseErrorMessage(error)}</Typography>
      </Stack>
    </PageLayout>
  );
};
